import WeakSet from '.WeakSet';
import has from '.WeakSet.prototype.has';
import add from '.WeakSet.prototype.add';
import getOwnPropertyNames from '.Object.getOwnPropertyNames';
import freeze from '.Object.freeze';
import isArray from '.Array.isArray';
import Null from '.null';

import { x } from '../j-lexer';/// external

import TOMLDocument from './document';
const linesFromStringify = new WeakSet                   ();
const beLinesFromStringify = /*#__PURE__*/add.bind(linesFromStringify);
export const isLinesFromStringify = /*#__PURE__*/has.bind(linesFromStringify);
export default (rootTable                , options                  )                    => {
	const document = new TOMLDocument(options);
	const section = document[0];
	section[0] = '';
	x      (section.assignBlock(``, ``, rootTable, getOwnPropertyNames(rootTable)));
	document.newlineUnderSectionButPair && section.length!==1 && section.appendNewline();
	document.newlineUnderSection || document[document.length - 1] .appendNewline();
	if ( document.newline ) { return document.join(document.newline); }
	const lines = document.flat();
	beLinesFromStringify(lines);
	return lines;
};

export { inline, Section } from '../types/non-atom';
export { _literal } from '../types/atom';
import { LiteralObject } from '../types/atom';
import { multilineTable, multilineArray } from '../types/non-atom';
import { singlelineBasicString, Lines, multilineString, multilineBasicString, multilineLiteralString, multilineNeedBasic } from './string';
export const multiline = /*#__PURE__*/( () => {
	const multiline = (value                                                   , string         ) =>
		typeof value==='string' ? LiteralObject(( multilineNeedBasic(value) ? multilineBasicString : multilineLiteralString )(( '\n' + value ).split('\n')         ), value) :
			isArray(value) ? LiteralObject(multilineString(Lines(value)), typeof string==='string' ? string : Null(null)) :
				multilineTable(value);
	multiline.basic = (lines                            , string         ) =>
		typeof lines==='string'
			? LiteralObject(multilineBasicString(( '\n' + lines ).split('\n')         ), lines)
			: LiteralObject(multilineBasicString(Lines(lines)), typeof string==='string' ? string : Null(null))
	;
	multiline.array = multilineArray;
	freeze(multiline);
	return multiline;
} )();
export const basic = (value        ) => LiteralObject(singlelineBasicString(value), value);
export const literal = (literal                               , ...chars          ) => {
	if ( typeof literal==='string' ) {
		if ( chars.length===1 ) {
			return LiteralObject(literal.includes('\n') ? literal.split('\n')                            : literal, chars[0]                            );
		}
	}
	else {
		let index = chars.length;
		if ( index ) {
			const { raw } = literal;
			literal = raw[index] ;
			while ( index ) { chars[--index] += raw[index] ; }
			literal = chars.join('') + literal;
		}
		else { literal = literal.raw[0] ; }
	}
	return LiteralObject(literal.includes('\n') ? literal.split('\n')                            : literal, Null(null));
};

                                            